import { createAction } from '../../libs/saga-utils';

const ns = 'permissions';

export const PERMISSIONS_TYPES = {
  LOAD_ALL_REQUEST: `${ns}/LOAD_ALL_REQUEST`,
  LOAD_ALL_SUCCESS: `${ns}/LOAD_ALL_SUCCESS`,
  LOAD_ALL_FAILURE: `${ns}/LOAD_ALL_FAILURE`
};

export const PERMISSIONS_ACTIONS = {
  loadAllRequest: createAction(PERMISSIONS_TYPES.LOAD_ALL_REQUEST, params => ({
    params
  })),
  loadAllSuccess: createAction(
    PERMISSIONS_TYPES.LOAD_ALL_SUCCESS,
    permissions => ({ permissions })
  ),
  loadAllFailure: createAction(PERMISSIONS_TYPES.LOAD_ALL_FAILURE, error => ({
    error
  }))
};
